import {Component, OnInit, Input, forwardRef, Output, EventEmitter} from '@angular/core';
import { SearchService, SEARCH_TYPE_ACOPIO, SEARCH_TYPE_ACOPIO_NEW_NEGOCIO} from '../../../../services/search-service';
import { Observable } from 'rxjs/Observable';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormControl } from '@angular/forms';
import { MdDialogRef, MdOptionSelectionChange, DateAdapter } from '@angular/material';


@Component({
  selector: 'app-acopio-autocomplete',
  templateUrl: './acopio-autocomplete.component.html',
  styleUrls: ['./acopio-autocomplete.component.scss'],
  providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => AcopioAutocompleteComponent),
        multi: true
      }
    ]
})
export class AcopioAutocompleteComponent implements OnInit, ControlValueAccessor {

  // Acopios
  public acopios = [];
  public acopioStateControl: FormControl;
  public filteredAcopios: Observable<any>;
  public selectedAcopios = [];
  public error: boolean;


  propagateChange = (_: any) => {};
  propagateTouched = (_: any) => {};

  @Input() placeholder: string = 'Filtrar por acopio/oficina';
  @Input('singleValue') singleValue = false;
  @Input('cantDelete') cantDelete = false;
  @Input('checkInputLength') checkInputLength: boolean = true;
  @Input('fullWidthLine') fullWidthLine = false;
  @Input('newNegocio') newNegocio = false;
  @Input('cuentaId') cuentaId: number = 0;

  @Input()
  set selection(selection) {
    // careful, copy the array in case you forgot to pass a copy instead of a reference
    this.selectedAcopios = selection.slice();
  }

  @Input()
  set valid(value){
    if(!value){
      this.acopioStateControl.setErrors({'incorrect': value});
    }
  }

  @Output() ItemsSelectedChanged = new EventEmitter<boolean>();
  @Output() ViewInitialized = new EventEmitter<{}>();

  constructor(private searchService: SearchService) {
    // Acopios
    this.acopioStateControl = new FormControl();

    this.filteredAcopios = this.acopioStateControl.valueChanges
        .startWith(null)
        .debounceTime(1000)
        .switchMap(value => {
          if ( (value && value.length > 2) && (!this.singleValue || this.selectedAcopios.length == 0)){
            if(this.newNegocio){
              return this.searchService.searchAutocomplete(value, SEARCH_TYPE_ACOPIO_NEW_NEGOCIO, 0, this.cuentaId);
            }else{
              return this.searchService.searchAutocomplete(value, SEARCH_TYPE_ACOPIO);
            }

          } else {
            return Observable.from([]);
          }
        })
        .map( value => {
          return value;
        });
  }

  ngOnInit() {
    setTimeout(_ => {
      this.ViewInitialized.emit();
    });
  }

  selectedAcopio(event: MdOptionSelectionChange, value: any) {
    if (this.singleValue && this.selectedAcopios.length > 0) {
      return;
    }

    if (event.source.selected &&
        this.selectedAcopios.filter(v => v.Id === value.Id).length === 0) {
        this.selectedAcopios.push(value);
        this.valid = this.selectedAcopios.length > 0;
        this.propagateChange(this.selectedAcopios);
    }
    this.ItemsSelectedChanged.emit(true);
  }

  removeAcopio(acopio){
    this.selectedAcopios.splice(this.selectedAcopios.findIndex(v => v.Id === acopio.Id), 1);
    this.valid = this.selectedAcopios.length > 0;
    this.propagateChange(this.selectedAcopios);
    this.ItemsSelectedChanged.emit(true);
  }

  displayFn(value){
    return null;
  }

  /*ControlValueAccessor implementation*/
  writeValue(value: any) {
    // Seteo el valor que ya viene seleccionado
    if(value !== null){
      this.selectedAcopios = value;
    }
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn) {
    this.propagateTouched = fn;
  }

  onTouched(event){
    if (this.checkInputLength) {
      this.valid = this.selectedAcopios.length > 0;
    }
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/autocomplete/acopio-autocomplete/acopio-autocomplete.component.ts